(() => {
  if (window.kmCartPreviewInitialized) return;
  window.kmCartPreviewInitialized = true;
  let dialog;
  let trigger;
  let slides = [];
  let activeIndex = 0;
  let imageAlt = '';
  let scrollLock;
  const lockScroll = () => {
    if (scrollLock) return;
    const body = document.body;
    const root = document.documentElement;
    const properties = ['position', 'top', 'left', 'width', 'overflow'];
    scrollLock = {
      x: window.scrollX,
      y: window.scrollY,
      body: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
      overflow: root.style.getPropertyValue('overflow'),
      overflowPriority: root.style.getPropertyPriority('overflow'),
    };
    root.style.setProperty('overflow', 'hidden', 'important');
    body.style.setProperty('position', 'fixed', 'important');
    body.style.setProperty('top', `${-scrollLock.y}px`, 'important');
    body.style.setProperty('left', `${-scrollLock.x}px`, 'important');
    body.style.setProperty('width', '100%', 'important');
    body.style.setProperty('overflow', 'hidden', 'important');
  };
  const unlockScroll = () => {
    if (!scrollLock) return;
    const saved = scrollLock;
    scrollLock = null;
    const root = document.documentElement;
    saved.body.forEach(([name, value, priority]) => {
      if (value) document.body.style.setProperty(name, value, priority);
      else document.body.style.removeProperty(name);
    });
    if (saved.overflow) root.style.setProperty('overflow', saved.overflow, saved.overflowPriority);
    else root.style.removeProperty('overflow');
    const behavior = root.style.getPropertyValue('scroll-behavior');
    const priority = root.style.getPropertyPriority('scroll-behavior');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(saved.x, saved.y);
    if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
    else root.style.removeProperty('scroll-behavior');
  };
  const showSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    const slide = slides[activeIndex];
    const image = dialog.querySelector('img');
    image.src = slide.url;
    image.alt = `${imageAlt}${slide.side ? ` — ${slide.side}` : ''}`;
    dialog.querySelector('[data-preview-label]').textContent = slide.side || 'Product image';
    dialog.querySelector('[data-preview-nav]').hidden = slides.length < 2;
  };
  const setup = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'km-cart-preview';
    dialog.setAttribute('aria-label', 'Product image preview');
    dialog.innerHTML = '<button type="button" class="km-cart-preview__close" aria-label="Close image preview">×</button><img class="km-cart-preview__image" alt=""><nav class="km-cart-preview__nav" data-preview-nav aria-label="Print side previews" hidden><button type="button" data-preview-previous aria-label="Previous print side">←</button><span data-preview-label aria-live="polite"></span><button type="button" data-preview-next aria-label="Next print side">→</button></nav>';
    document.body.append(dialog);
    dialog.querySelector('[data-preview-previous]').addEventListener('click', () => showSlide(activeIndex - 1));
    dialog.querySelector('[data-preview-next]').addEventListener('click', () => showSlide(activeIndex + 1));
    dialog.addEventListener('keydown', event => {
      if (slides.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    const close = () => dialog.close();
    dialog.querySelector('button').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      unlockScroll();
      dialog.querySelector('img').removeAttribute('src');
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-km-cart-preview]');
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    if (!dialog) setup();
    trigger = link;
    const thumbnail = link.querySelector('img');
    let source = thumbnail?.currentSrc || thumbnail?.src || link.href;
    try {
      const url = new URL(source, location.href);
      if (url.pathname.includes('/cdn/shop/') || url.hostname === 'cdn.shopify.com') {
        url.searchParams.set('width', '1800');
        source = url.href;
      }
    } catch { source = link.href; }
    imageAlt = thumbnail?.alt || 'Product image preview';
    slides = [
      { side: link.dataset.kmPreviewFrontLabel || 'Front', url: link.dataset.kmPreviewFront },
      { side: link.dataset.kmPreviewBackLabel || 'Back', url: link.dataset.kmPreviewBack },
    ].filter(slide => slide.url);
    if (!slides.length) slides = [{ url: source }];
    showSlide(0);
    if (!dialog.open) {
      dialog.showModal();
      lockScroll();
    }
  }, true);
})();
